<template>
  <div class="community">
    <div class="inner">
      <div class="nav" v-if="clientWidth > 900">
        <el-row>
          <el-col :span="12">
            <el-row align="middle">
              <el-col :span="15"
                ><el-tabs v-model="section" @tab-click="handleClick">
                  <el-tab-pane :label="$t('玩家討論區')" name="1"></el-tab-pane>
                  <el-tab-pane :label="$t('攻略討論區')" name="2"></el-tab-pane>
                  <el-tab-pane
                    :label="$t('圖片分享區')"
                    name="3"
                  ></el-tab-pane> </el-tabs
              ></el-col>
              <el-col :span="4">
                <el-button @click="add" round type="primary">
                  {{ $t("發文") }}
                </el-button>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-input
              :placeholder="$t('請輸入')"
              v-model="search"
              class="input-with-select"
            >
              <el-select
                v-model="section"
                slot="prepend"
                placeholder=""
                style="width: 150px"
              >
                <el-option :label="$t('玩家討論區')" value="1"></el-option>
                <el-option :label="$t('攻略討論區')" value="2"></el-option>
                <el-option :label="$t('圖片分享區')" value="3"></el-option>
              </el-select>
              <el-button
                slot="append"
                style="background: #c6a86c; color: #fff; border-radius: 0"
                >{{ $t("搜索") }}</el-button
              >
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="mobile-nav" v-else>
        <div
          :class="recent_type === item.value ? 'nav-active' : 'mobile-nav-item'"
          v-for="(item, index) in navData"
          @click="mobileHandleClick(item)"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="mobile-add" v-if="clientWidth <= 900">
        <el-button @click="add" round type="primary">
          {{ $t("發文") }}
        </el-button>
      </div>
      <div class="message_list" v-if="communityList.length > 0">
        <div
          class="message_list_item"
          v-for="(item, index) in communityList"
          :key="index"
          @click="detail(item)"
        >
          <div class="detail">
            <div class="title_time">
              <el-row>
                <el-col :span="18">
                  <div class="title">
                    <span>{{ item.article.title }}</span>
                  </div>
                </el-col>
                <el-col :span="4" v-if="clientWidth > 900">
                  <div class="nickname">{{ item.article.author_nickname }}</div>
                </el-col>
                <el-col :span="2" v-if="clientWidth > 900">
                  <div class="time">
                    {{ $formatTime(item.modify_at, "yearMonthDay") }}
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="desc">
              <span>{{ item.article.abstract }}</span>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        :total="total"
        @repeater="repeater"
        v-if="communityList.length > 0"
      />
      <Nodata v-else />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getCommunityList } from "@/api/communities";
export default {
  data() {
    return {
      activeName: "0",
      total: 0,
      section: "1",
      value: "",
      page: 1,
      communityList: [],
      search: "",
      recent_type: "1",
      navData: [
        {
          name: this.$t("玩家討論區"),
          value: "1",
        },
        {
          name: this.$t("攻略討論區"),
          value: "2",
        },
        {
          name: this.$t("圖片分享區"),
          value: "3",
        },
      ],
    };
  },
  mounted() {
    this.recent_type = this.$store.state.header.currentTpye;
    this.getData();
  },
  computed: {
    ...mapState({
      currentTpye: (state) => state.header.currentTpye,
      clientWidth: (state) => state.screen.clientWidth,
    }),
  },
  watch: {
    currentTpye(newVal) {
      this.section = newVal;
      this.getData();
    },
  },
  methods: {
    async getData() {
      const res = await getCommunityList({
        page: this.page,
        limit: 10,
        section: this.section,
        search: this.search,
      });
      this.total = res.data.paging.total;
      this.communityList = res.data.results;
    },
    add() {
      this.$router.push(`/addcommunity?type=${this.section}`);
    },
    detail(item) {
      this.$router.push(`/communityDetail?id=${item.id}`);
    },
    repeater(page) {
      this.page = page;
      this.getData();
    },
    handleClick() {
      this.getData();
    },
    mobileHandleClick(item) {
      this.section = item.value;
      this.recent_type = item.value;
      this.getData();
    },
  },
};
</script>
<style lang="scss" scoped>
.community {
  width: 100%;
  background-image: url("~@/assets/img/home/bg_currency.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  min-height: 80vh;
  .inner {
    width: 1200px;
    margin: 0 auto;
    @media only screen and (max-width: 900px) {
      width: 90%;
    }
    .nav {
      margin: 40px 0;
    }
    .mobile-nav {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      @media only screen and (max-width: 900px) {
        margin-bottom: 20px;
        font-size: 14px;
      }
      &-item {
        @media only screen and (max-width: 900px) {
          flex: 1;
          text-align: center;
          height: 40px;
          line-height: 40px;
        }
      }
      .nav-active {
        @media only screen and (max-width: 900px) {
          flex: 1;
          text-align: center;
          height: 40px;
          line-height: 40px;
          color: #c6a86c;
          border-bottom: 2px solid #c6a86c;
        }
      }
    }
    .mobile-add {
      text-align: left;
      @media only screen and (max-width: 900px) {
        margin-bottom: 20px;
      }
    }
    .message_list {
      margin-bottom: 40px;
      @media only screen and (max-width: 900px) {
        margin-bottom: 20px;
      }
      .message_list_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        margin-bottom: 40px;
        @media only screen and (max-width: 900px) {
          margin-bottom: 20px;
        }
        .tag {
          text-align: center;
          min-width: 64px;
          color: #fff;
          font-size: 14px;
          background-color: #c6a86c;
          height: 30px;
          line-height: 30px;
          margin-right: 26px;
          @media only screen and (max-width: 900px) {
            height: 30px;
            line-height: 30px;
            margin-right: 26px;
          }
        }
        .detail {
          flex: 1;
          overflow: hidden;
          .title_time {
            width: 100%;
            margin-bottom: 16px;
            overflow: hidden;
            .title {
              flex: 1;
              color: #676a6d;
              font-size: 22px;
              text-align: left;
              overflow: hidden; //文本溢出隐藏
              text-overflow: ellipsis; //文本溢出显示省略号
              white-space: nowrap; //不换行
              @media only screen and (max-width: 900px) {
                font-size: 14px;
              }
            }
            .nickname {
              color: #a8adb3;
            }
            .time {
              color: #a8adb3;
              font-size: 16px;
              text-align: right;
            }
          }
          .desc {
            text-align: left;
            // margin-bottom: 40px;
            span {
              text-align: left;
              overflow: hidden; //文本溢出隐藏
              text-overflow: ellipsis; //文本溢出显示省略号
              white-space: nowrap; //不换行
              font-size: 16px;
              color: #676a6d;
            }
          }
        }
      }
    }
  }
}
::v-deep .el-input-group__prepend {
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 20px !important;
}
::v-deep .el-input-group__append {
  border-top-right-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  overflow: hidden;
  background-color: #c6a86c;
}
::v-deep .el-tabs__nav-scroll {
  width: 100%;
}
::v-deep .is-top::after {
  background-color: transparent;
}
::v-deep .is-active {
  color: #c6a86c;
}
::v-deep .el-tabs__active-bar {
  background-color: #c6a86c;
  height: 3px;
}
::v-deep .el-tabs__item {
  &:hover {
    color: #c6a86c;
  }
  font-size: 18px;
}
</style>
